<template>
    <div v-if="copySetting && copySetting.chart">
        <div class="row form-group m-t-10">
            <div class="col-md-12">
                <a
                    href="javascript:;"
                    class="xe-tab-underline"
                    @click="toggleTabs('general')"
                    :class="{ 'xe-tab-line-orange': tabs.general }"
                >
                    <trans>일반</trans>
                </a>
                <a
                    href="javascript:;"
                    class="xe-tab-underline"
                    @click="toggleTabs('chartOptions')"
                    :class="{ 'xe-tab-line-orange': tabs.chartOptions }"
                >
                    <trans>차트 옵션</trans>
                </a>
                <a
                    href="javascript:;"
                    class="xe-tab-underline"
                    @click="toggleTabs('point')"
                    :class="{ 'xe-tab-line-orange': tabs.point }"
                >
                    <trans>관제점</trans>
                </a>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <div class="tab-content">
                    <div class="tab-pane fade" :class="{ 'active show': tabs.general }">
                        <label>&nbsp;</label>
                        <div class="row form-group">
                            <div class="col-12">
                                <label>
                                    <h6>
                                        <i class="fa fa-check"></i>
                                        <trans>항목명</trans>
                                    </h6>
                                </label>

                                <div class="row form-group align-items-center">
                                    <div class="col-md-6">
                                        <valid-input
                                            :inputType="'text'"
                                            :inputValue.sync="copySetting.title"
                                            :rules="rules.DASHBOARD_WIDGET_ITEM_NAME_RULE"
                                            :classList="'form-control'"
                                            :NonStatus="true"
                                        >
                                        </valid-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row form-group">
                            <div class="col-12">
                                <label>
                                    <h6>
                                        <i class="fa fa-check"></i>
                                        <trans>기본 기간</trans>
                                    </h6>
                                </label>
                                <div class="row form-group align-items-center">
                                    <div class="col-md-6">
                                        <select class="form-control" v-model="copySetting.periodMode">
                                            <option value="DAY">{{ $t("일간") }}</option>
                                            <option value="MONTH">{{ $t("월간") }}</option>
                                            <option value="YEAR">{{ $t("연간") }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>

                    <div class="tab-pane fade" :class="{ 'active show': tabs.chartOptions }">
                        <label>&nbsp;</label>
                        <div class="row form-group">
                            <div class="col-12">
                                <h6>
                                    <i class="fa fa-check"></i>
                                    <trans>차트 옵션</trans>
                                </h6>
                            </div>
                        </div>

                        <!-- 공통 설정 -->
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label
                                    ><b>
                                        <trans>공통</trans>
                                    </b></label
                                >
                            </div>
                            <div class="col-md-10">
                                <div class="row form-group align-items-center">
                                    <div class="col-md-3">
                                        <label>
                                            <trans>격자 색상</trans>
                                        </label>
                                        <br />
                                        <energy-color-palette v-model="copySetting.chart.gridColor" />
                                    </div>
                                    <div class="col-md-3">
                                        <label>
                                            <trans>소수점자리</trans>
                                        </label>
                                        <valid-input
                                            :inputType="'number'"
                                            :inputValue.sync="copySetting.addition.fixed"
                                            :classList="'form-control'"
                                            :NonStatus="false"
                                            :errorMessage="
                                                validMessage.WIDGET_DECIMAL_AND_FONTSIZE_LENGTH_VALID_MESSAGE
                                            "
                                            :rules="rules.DASHBOARD_WIDGET_DECIMAL_RULE"
                                        >
                                        </valid-input>
                                    </div>
                                    <div class="col-md-2 m-t-10">
                                        <label>&nbsp;</label>
                                        <div class="checkbox checkbox-css">
                                            <input
                                                type="checkbox"
                                                :id="'chart_stacked' + copySetting.id"
                                                v-model="copySetting.chart.options.stacked"
                                            />
                                            <label :for="'chart_stacked' + copySetting.id">
                                                <trans>스택</trans>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- //공통 설정 -->

                        <!-- 범례 설정 -->
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label
                                    ><b>
                                        <trans>범례</trans>
                                    </b></label
                                >
                            </div>
                            <div class="col-md-10">
                                <div class="row form-group align-items-center">
                                    <div class="col-md-2">
                                        <label>
                                            <trans>위치</trans>
                                        </label>
                                        <select
                                            class="form-control"
                                            v-model="copySetting.chart.options.legend.position"
                                        >
                                            <option value="top">{{ $t("상단") }}</option>
                                            <option value="bottom">{{ $t("하단") }}</option>
                                            <!-- <option value="left">{{ $t("좌측") }}</option>
                                            <option value="right">{{ $t("우측") }}</option> -->
                                        </select>
                                    </div>
                                    <div class="col-md-2">
                                        <label>
                                            <trans>정렬</trans>
                                        </label>
                                        <select class="form-control" v-model="copySetting.chart.options.legend.align">
                                            <option value="start">{{ $t("시작") }}</option>
                                            <option value="center">{{ $t("중앙") }}</option>
                                            <option value="end">{{ $t("끝") }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-2">
                                        <label>
                                            <trans>폰트 크기</trans>
                                        </label>
                                        <valid-input
                                            :inputType="'number'"
                                            :inputValue.sync="copySetting.chart.options.legend.labels.fontSize"
                                            :rules="rules.DASHBOARD_WIDGET_FONTSIZE_RULE"
                                            :errorMessage="
                                                validMessage.WIDGET_DECIMAL_AND_FONTSIZE_LENGTH_VALID_MESSAGE
                                            "
                                        >
                                        </valid-input>
                                    </div>
                                    <div class="col-md-3">
                                        <label>
                                            <trans>폰트 색상</trans>
                                        </label>
                                        <br />
                                        <energy-color-palette
                                            v-model="copySetting.chart.options.legend.labels.fontColor"
                                        />
                                    </div>
                                    <div class="col-md-2">
                                        <label>&nbsp;</label>
                                        <div class="checkbox checkbox-css">
                                            <input
                                                type="checkbox"
                                                :id="'linechart_yAxes_left_display' + copySetting.id"
                                                v-model="copySetting.chart.options.yAxes.left.display"
                                            />
                                            <label :for="'linechart_yAxes_left_display' + copySetting.id">
                                                <trans>화면표시</trans>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- //범례 설정 -->

                        <!-- Y축 설정 -->
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label
                                    ><b>
                                        <trans>y축</trans>
                                    </b></label
                                >
                            </div>
                            <div class="col-md-10">
                                <div class="row form-group align-items-center">
                                    <div class="col-md-3">
                                        <label>
                                            <trans>표시명</trans>
                                        </label>
                                        <valid-input
                                            :inputType="'text'"
                                            :inputValue.sync="copySetting.chart.options.yAxes.left.label"
                                            :rules="rules.DASHBOARD_WIDGET_VIEW_NAME_RULE"
                                            :NonStatus="true"
                                            :classList="'form-control'"
                                        >
                                        </valid-input>
                                    </div>

                                    <div class="col-md-3">
                                        <label>
                                            <trans>단위</trans>
                                        </label>
                                        <valid-input
                                            :inputType="'text'"
                                            :inputValue.sync="copySetting.chart.options.yAxes.left.unit"
                                            :rules="rules.DASHBOARD_WIDGET_UNIT_RULE"
                                            :NonStatus="true"
                                            :classList="'form-control'"
                                        >
                                        </valid-input>
                                    </div>

                                    <div class="col-md-3">
                                        <label>
                                            <trans>폰트 색상</trans>
                                        </label>
                                        <br />
                                        <energy-color-palette
                                            v-model="copySetting.chart.options.yAxes.left.fontColor"
                                        />
                                    </div>
                                    <div class="col-md-2">
                                        <label>&nbsp;</label>
                                        <div class="checkbox checkbox-css">
                                            <input
                                                type="checkbox"
                                                :id="'yAxes_left_display' + copySetting.id"
                                                v-model="copySetting.chart.options.yAxes.left.display"
                                            />
                                            <label :for="'yAxes_left_display' + copySetting.id">
                                                <trans>화면표시</trans>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-3 m-t-10">
                                        <label>
                                            <trans>폰트 크기</trans>
                                        </label>
                                        <valid-input
                                            :inputType="'number'"
                                            :inputValue.sync="copySetting.chart.options.yAxes.left.fontSize"
                                            :rules="rules.DASHBOARD_WIDGET_FONTSIZE_RULE"
                                            :errorMessage="
                                                validMessage.WIDGET_DECIMAL_AND_FONTSIZE_LENGTH_VALID_MESSAGE
                                            "
                                        >
                                        </valid-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- X축 설정 -->
                        <div class="row form-group">
                            <div class="col-md-2">
                                <label
                                    ><b>
                                        <trans>X축</trans>
                                    </b></label
                                >
                            </div>
                            <div class="col-md-10">
                                <div class="row form-group align-items-center">
                                    <div class="col-md-3">
                                        <label>
                                            <trans>폰트 크기</trans>
                                        </label>
                                        <valid-input
                                            :inputType="'number'"
                                            :inputValue.sync="copySetting.chart.chartFontSize"
                                            :rules="rules.DASHBOARD_WIDGET_FONTSIZE_RULE"
                                            :errorMessage="
                                                validMessage.WIDGET_DECIMAL_AND_FONTSIZE_LENGTH_VALID_MESSAGE
                                            "
                                        >
                                        </valid-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>

                    <div class="tab-pane fade" :class="{ 'active show': tabs.point }">
                        <div v-for="(series, i) in copySetting.chart.series || []" :key="i">
                            <div class="row form-group">
                                <div class="col-md-4">
                                    <label> <trans>표시명</trans> {{ i + 1 }} </label>
                                    <div class="row">
                                        <div class="col-md-7">
                                            <b-input type="text" v-model="series.label" />
                                        </div>
                                        <div class="col-md-2">
                                            <energy-color-palette v-model="series.dataColor" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>
                                        <trans>관제점</trans>
                                    </label>
                                    <div :style="{ fontWeight: 'normal' }">
                                        <tree-select
                                            class="col-12 pr-0 pl-0"
                                            v-model="series.point"
                                            :options="searchPointInfoOptions"
                                            :disable-branch-nodes="true"
                                            :placeholder="$t(controlMessages.POINT_TREE_PLACEHOLDER_MESSAGE)"
                                            :noChildrenText="$t(controlMessages.POINT_TREE_NOCHILDERN_MESSAGE)"
                                            :noResultsText="$t(controlMessages.COMMON_TREE_NOSEARCH_MESSAGE)"
                                            :open-on-focus="true"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <label>&nbsp;</label>
                                    <b-dropdown
                                        text=""
                                        variant="default"
                                        toggle-class=""
                                        class="pull-left"
                                        style="margin-top: 25px"
                                    >
                                        <b-dropdown-item @click="deleteSeries(i)">
                                            <trans>삭제</trans>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                            <legend></legend>
                        </div>
                        <div class="row form-group m-0">
                            <button class="btn btn-white m-auto" @click="insertSeries()">
                                <i class="fa fa-plus width-100"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row form-group">
            <div class="col-md-12 p-0">
                <div slot="modal-footer" class="w-100">
                    <button class="btn btn-primary m-r-5 pull-right" @click="onModalOK()">
                        <trans>확인</trans>
                    </button>
                    <button class="btn btn-secondary pull-right m-r-10" @click="onModalCancel()">
                        <trans>취소</trans>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import backEndApi from "@src/api/backEndApi";
import xeBaseSetting from "@src/views/widget/v1/common/xeBaseSetting.js";
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts.js";
import * as popupMessages from "@src/consts/popupMessageConsts";
import * as controlMessages from "@src/consts/controlMessageConsts";
import EnergyColorPalette from "@src/components/colorpalette/EnergyColorPalette.vue";

export default {
    extends: xeBaseSetting,
    data() {
        return {
            tabs: {
                general: true,
                point: false,
                chartOptions: false,
            },
            searchPoint: null,
            searchPointInfoOptions: [],
            rules,
            validMessage,
            popupMessages,
            controlMessages,
        };
    },
    components: {
        EnergyColorPalette,
    },
    mounted() {
        this.getSearchPoint();
    },
    methods: {
        toggleTabs(tab) {
            if (tab == "general") {
                this.tabs.general = true;
                this.tabs.point = false;
                this.tabs.chartOptions = false;
            } else if (tab == "chartOptions") {
                this.tabs.general = false;
                this.tabs.point = false;
                this.tabs.chartOptions = true;
            } else if (tab == "point") {
                this.tabs.general = false;
                this.tabs.point = true;
                this.tabs.chartOptions = false;
            }
        },

        insertSeries() {
            // chart.series 초기화 확인
            if (!this.copySetting.chart) {
                this.$set(this.copySetting, "chart", {});
            }
            if (!this.copySetting.chart.series) {
                this.$set(this.copySetting.chart, "series", []);
            }

            const newIndex = this.copySetting.chart.series.length + 1;
            const newSeries = {
                type: "spline",
                label: `Default ${newIndex}`,
                point: "",
                position: "Left",
                backgroundColor: "rgba(52, 143, 226, 0.3)",
                fill: false,
                compare: false,
                dataColor: "#000000",
            };

            // Vue 반응성을 위해 $set 사용 또는 배열 메서드 사용
            this.copySetting.chart.series.push(newSeries);

            // 강제 업데이트 (필요시)
            this.$forceUpdate();
        },
        deleteSeries(idx) {
            this.copySetting.chart.series.splice(idx, 1);
        },
        getSearchPoint() {
            this.searchPointInfoOptions = [];

            backEndApi.pointInfo.getPointByGroup().then(({ data }) => {
                this.searchPoint = data;

                this.searchPoint.map((point) => {
                    const pointList = point.pointList;
                    const groupObject = {
                        id: point.groupCode,
                        label: point.groupCodeName,
                        children: [],
                    };

                    for (let i = 0; i < pointList.length; i++) {
                        groupObject.children.push({
                            id: pointList[i].ptAddr,
                            label: pointList[i].ptName,
                        });
                    }

                    this.searchPointInfoOptions.push(groupObject);
                });

                this.searchPointInfoOptions.sort((a, b) => {
                    return a.label.localeCompare(b.label);
                });

                this.searchPointInfoOptions.unshift({
                    id: "",
                    label: "전체",
                });
            });
        },
    },
};
</script>
